import * as actionTypes from "./AccountModeModalActionTypes";
import { Dispatch, UnknownAction } from "redux";

export const closeAccountModeModalAction = () => (dispatch: Dispatch<UnknownAction>) => {
  dispatch({ type: actionTypes.ACCOUNT_MODE_MODAL_CLOSE });
};
